import React, { useEffect, useState } from 'react';
import Header from '../../Presale/Header';
import Footer from '../../Footer';
import '../../css/presale.css'
import Stage1 from '../../Presale/Stage1'
import Stage2 from '../../Presale/Stage2'
import AccordionBox from '../../Presale/Accordion'
import Banner from '../../Presale/Banner'
import Rangeslider from '../../Presale/Rangeslider'



import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { getInfiTokenPrice, getPresaleStatistics, getUsdtAddress } from '../../../../services/apiServices';
import { Link } from 'react-router-dom';
import config from '../../../../config';
;



const Presale = () => {
    const [openBuyForm, setOpenBuyForm] = useState(false);
    const [connectWalletNow, setconnectWalletNow] = useState(false);
    const [InfiTokenPrice, setInfiTokenPrice] = useState(0);
    const [UsdtContract, setUsdtContract] = useState("")
    const [presaleContract, setpresaleContract] = useState("");
    const [totalSold, setTotalSold] = useState(0);

    useEffect(() => {
        getPrice()
        getUsdtContract()
    }, [])
    const getPrice = async () => {
        const res = await getInfiTokenPrice();
        const resStatistics = await getPresaleStatistics();
        if (res.data?.status) {
            setInfiTokenPrice(parseFloat(res.data.data.infiprice));
            setpresaleContract(resStatistics.data.data.PreSaleAddress || "")
            setTotalSold(resStatistics.data.data.SoldOutToken || 0)
        }
    }
    const getUsdtContract = async () => {
        const res = await getUsdtAddress();
        if (res.data?.status) {
            setUsdtContract(res.data.data.usdtAddress);
        }
    }
    return (
        <>
            <Header showBuyBtn={true} setOpenBuyForm={setOpenBuyForm} connectWalletNow={connectWalletNow} setconnectWalletNow={setconnectWalletNow} />
            <div className='mainHeading text-center'>
                <h1 class="text-primary"><b>ICO IS LIVE!</b></h1>
            </div>
            <div className="presale pt-5 pb-4">

                <div className='bg_presale'>
                    <img src='assets/images/presale/bg_presale.svg' width={`100%`} />

                </div>
                <div className='shapeEllipse'>
                    <img src='assets/images/shape1.svg' className='shape shape1' />
                    <img src='assets/images/shape2.svg' className='shape shape2' />
                </div>
                <Banner />
            </div>
            <section className='stage pt-4 pb-4'>
                <Container>
                    <Row className='justify-content-center mobile-row-reverse' >
                        <Col lg={5} className=''>
                            <Stage1
                                openBuyForm={openBuyForm}
                                setOpenBuyForm={setOpenBuyForm}
                                setconnectWalletNow={setconnectWalletNow}
                                InfiTokenPrice={InfiTokenPrice}
                                UsdtContract={UsdtContract}
                                presaleContract={presaleContract}
                            />
                        </Col>
                        <Col lg={1} className=''>

                        </Col>
                        <Col lg={6} className=''>
                            <div className='p-4 p-xs-0'>
                                <img src='assets/images/presale/robot_nft.png' />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>
            <section className='stage pt-4 pb-4'>
                <Container>
                    <Row className='justify-content-center' >
                        <Col lg={6} className=''>
                            <div className='p-4 p-xs-0'>
                                <img src='assets/images/presale/robot_nft2.png' />
                            </div>
                        </Col>
                        <Col lg={1} className=''>

                        </Col>
                        <Col lg={5} className='text-right'>
                            <Stage2 />
                        </Col>

                    </Row>

                </Container>
            </section>
            <section className='pt-4 pb-4'>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className=''>
                                <h1 className='text-blue text-gradient mb-3 fw-bold'>INFI Progress</h1>
                            </div>
                            <div className='pb-2 px-3'>
                                <Rangeslider totalSold={totalSold} />

                            </div>

                        </Col>
                    </Row>
                </Container>

            </section>
            <section className='stage pt-4 pb-4'>
                <Container>
                    <Row className='justify-content-center mobile-row-reverse' >

                        <Col lg={7} className='text-left'>
                            <h1 className='text-blue text-uppercase text-gradient mb-3'><b>FAQ</b></h1>
                            <AccordionBox />
                        </Col>
                        <Col lg={5} className=''>
                            <div className='faqImage p-5'>
                                <img src='assets/images/presale/faq.svg' />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>
            <section className="communitytool pt-5 pb-5 position-relative">
                <Container>
                    <div className='pt-5 pb-5 cardBox' style={{ background: "rgb(54 54 54 / 71%)" }}>
                        <Row className='align-items-center  text-center' >
                            <Col lg={12}>
                                <div className='mb-3'>
                                    <h1>IMPRESSED? Join the INFI Community Today!</h1>
                                </div>
                                <a href='#'> <Button variant="outline-primary" className="me-2 text-uppercase px-4 mb-2">NO? Start from top again!</Button></a>
                                <Link to={`${config.baseurl}signup`}> <Button variant="primary" className='text-uppercase px-4 mb-2 text-black fw-bold'>sign UP Today!</Button></Link>
                            </Col>

                        </Row>
                    </div>
                </Container>
            </section>
            <section>
                <Container>
                    <div className='pt-5 pb-5'>
                        <Row className='justify-content-center  text-center' >

                            <Col lg={8}>
                                <div className='mb-4'>
                                    <h1>Our Business Partners</h1>
                                </div>
                                <div className='partner mt-4 text-center'>
                                    <a href='https://solidproof.io/' className='me-5 mb-3'><img src='assets/images/logo/solidproof.png' /></a>
                                    <a href='https://idopresales.com/' className='me-5 mb-3'><img src='assets/images/logo/IDOPresales.png' /></a>
                                    <a href='https://coinsult.net/' className=' me-5 mb-3'><img src='assets/images/logo/coinsult.png' /></a>
                                    <a href='https://nexo.com/' className='mb-3'>
                                        <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.05 0.555 141.93 33.545" xmlns="http://www.w3.org/2000/svg" viewBox="0.05 0.555 141.93 33.545" height="35" width="142" data-type="color" role="presentation" aria-hidden="true">
                                        <g>
                                            <path fill="#2853C3" d="M131.664 8a10.458 10.458 0 0 0-7.583 17.8 10.46 10.46 0 0 0 11.412 2.33 10.453 10.453 0 0 0 6.487-9.674 10.452 10.452 0 0 0-10.316-10.455Zm0 16.416a6.03 6.03 0 1 1-.648-12.042 6.03 6.03 0 0 1 .648 12.042Z" data-color="1"></path>
                                            <path fill="#2853C3" d="M117.434 8.145a.28.28 0 0 0-.385 0l-7.09 7.003-7.002-7.003a.28.28 0 0 0-.386 0l-2.853 2.959a.28.28 0 0 0 0 .385l7.002 7.002-7.107 7.108a.28.28 0 0 0 0 .385l2.801 2.784a.334.334 0 0 0 .49 0l7.003-7.003 7.002 7.003a.28.28 0 0 0 .385 0l2.854-2.836a.281.281 0 0 0 0-.385l-7.003-7.003 7.108-7.003a.282.282 0 0 0 0-.385l-2.819-3.01Z" data-color="1"></path>
                                            <path fill="#2853C3" d="M97.951 17.335c-.434-5.193-4.76-9.29-10.055-9.335-1.51 0-2.987.319-4.355.957-3.75 1.753-5.848 5.473-5.848 9.54.206 5.517 4.921 10.048 10.445 10.048h5.797c.309 0 .566-.25.566-.567v-3.317a.567.567 0 0 0-.566-.566h-6.047c-2.53 0-4.678-1.883-5.45-4.156h14.829c.404 0 .728-.302.728-.67-.007-.463-.044-1.934-.044-1.934Zm-4.766-1.067H82.46c.875-2.464 3.31-4.045 5.907-3.795 2.25.213 4.067 1.758 4.817 3.795Z" data-color="1"></path>
                                            <path fill="#2853C3" d="M64.71 8.01a9.786 9.786 0 0 0-5.357 1.75V8.605a.35.35 0 0 0-.35-.35h-3.747a.35.35 0 0 0-.35.35v9.33a4.235 4.235 0 0 0 0 .473v9.524a.577.577 0 0 0 .56.578h3.326a.56.56 0 0 0 .56-.578V18.18a5.74 5.74 0 0 1 6.303-5.707 5.865 5.865 0 0 1 5.252 5.882v9.61a.561.561 0 0 0 .56.578h3.309a.578.578 0 0 0 .577-.577V18.18A10.206 10.206 0 0 0 64.71 8.009Z" data-color="1"></path>
                                            <path fill="#60BEFF" d="M.05 6.147v21.927a.75.75 0 0 0 .385.652l9.618 5.374V11.722L.05 6.147Z" data-color="2"></path>
                                            <path fill="#1A4199" d="m30.023.556 9.618 5.373a.774.774 0 0 1 .28.277.743.743 0 0 1 .104.375V28.51l-10.002-5.59V.555Z" data-color="3"></path>
                                            <path fill="#3CA9E5" d="m10.036 34.1 10.002-5.59-10.002-5.591v11.18Z" data-color="4"></path>
                                            <path fill="#3CA9E5" d="m10.421.774 19.603 10.964v11.18L.05 6.149 9.668.773a.755.755 0 0 1 .753 0Z" data-color="4"></path>
                                            <path fill="#2853C3" d="m30.024.556-9.986 5.59 9.986 5.591V.556Z" data-color="1"></path>
                                            <path fill="#2853C3" d="m40.025 28.509-9.617 5.373a.839.839 0 0 1-.77 0L10.037 22.918V11.722l29.99 16.787Z" data-color="1"></path>
                                        </g>
                                    </svg></a>
                                </div>
                            </Col>

                        </Row>
                    </div>
                </Container>
            </section>
            <Container>
                <hr className='mt-0 mb-0' />
            </Container>
            <Footer className="pt-0" />
        </>
    )
}

export default Presale
